<twc-popup type="primary" caption="{{'PERMISSION_DIALOG.SELECT_GROUPS' | translate}}" width="l" #addGroupPopup>
    <twc-popup-content>

        <div class="twc-row twc-mt-3">
            <div class="twc-col-12">
                <twc-list class="permissions-element-list">
                    <twc-list-item *ngFor="let group of groupList"
                        [ngClass]="{'selected-row': isSelectedGroupId(group.uid)}" (click)="onSelect(group.uid)">
                        <div class="twc-list-item-col-1"
                            [ngClass]="{'group-already-added': isGroupAlreadyAdded(group.uid)}">
                            {{group.name}}
                        </div>
                    </twc-list-item>
                </twc-list>
            </div>
        </div>
    </twc-popup-content>

    <twc-popup-footer class="twc-mt-3">
        <button class="twc-button twc-button-link" (click)="closePopup()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
        <button class="twc-button twc-ml-2 twc-button-primary" (click)="addGroups()" [disabled]="!selectedGroups.length">
            {{'PERMISSION_DIALOG.ADD' | translate}}
        </button>
    </twc-popup-footer>

</twc-popup>